/* eslint-disable */

import axios from "axios";
import moment from "moment";
import { tz } from "../../../utils/timezone";

const url = require("../../client_config/config").url;

const state = {
  loading: false,
  unsigned: [],
  snackbar: { show: false, text: "", color: "green accent-4" },
  adlDocuments: [],
  adlAttachments: [],
  unverified: [],
};

const getters = {
  getUnsignedData: (state) => state.unsigned,
  getADLDocuments: (state) => state.adlDocuments,
  getADLAttachments: (state) => state.adlAttachments,
  getUnverifiedADL: (state) => state.unverified,
};

const actions = {
  //Add ADL
  async addADL({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.post(`${url}/adl`, data);
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  async getUnsigned({ commit }, data) {
    try {
      const response = await axios.get(`${url}/ADL/unsigned/${data.id}`);
      const adls = response.data.data.map((item) => {
        item.Date = moment(item.Date).format("YYYY-MM-DD");
        return {
          ...item,
          ServiceName: `${item.Service.Type} - ${item.Service.ServiceItem}`,
          Date: tz(item.Date, data.userTimezone).format("YYYY-MM-DD"),
        };
      });

      commit("SET_ADL", adls);
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async getClientUnverifiedADL({ commit }, id) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/adl/all/unverified/${id}`);
      console.log(response)
      if (response.data.success) {
        commit("SET_ALL_UNVERIFIED", response.data.adl);
        commit("SET_LOADING", false);
      }
      return response.data.adl;
    } catch (error) {
      console.error(error.response);
      commit("SET_LOADING", false);
      return error.response;
    }
  },

  async viewImages({ commit }, data) {
    try {
      const response = await axios.get(
        `${url}/ADL/documents/${data.clientID}`,
        {
          params: data,
        }
      );
      commit("SET_ADL_DOCUMENTS", response.data.data[0] || {});
      return response.data;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async viewAttachments({ commit }, id) {
    try {
      const response = await axios.get(
        `${url}/ADL/attachments/${id}`,
      );
      commit("SET_ADL_ATTACHMENTS", response.data.data[0] || {});
      return response.data;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async updateADLItem({ commit }, { data, id, unsigned }) {
    try {
      const response = await axios.put(`${url}/adl/${id}`, data, {
        params: { unsigned }
      });
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async verifyADL({ commit }, { id, data }) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.put(`${url}/adl/verify/${id}`, data);
      if (response.data.success) {
        commit("SET_UNVERIFIED", data);
        commit("SET_LOADING", false);
      }
      return response.data;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async updateADLImage({ commit }, { id, data }) {
    console.log(id, data )
    commit("SET_LOADING", true);
    try {
      const response = await axios.put(`${url}/adl/skin-check/update/${id}`, {documentId: data});
      if (response.data.success) {
        commit("SET_LOADING", false);
      }
      return response.data;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },
};

const mutations = {
  SET_ADL(state, data) {
    state.unsigned = data;
  },

  SET_ALL_UNVERIFIED(state, data) {
    state.unverified = [];
    data.map((item) => {
      item.Date = moment(item.Date).format("YYYY-MM-DD");
      state.unverified.push(item);
    });
  },

  SET_UNVERIFIED(state, data) {
    state.unverified = state.unverified.filter(
      (item) => !data.selectedIds.includes(item._id)
    );
  },

  SET_LOADING(state, data) {
    state.loading = data;
  },

  SET_ADL_DOCUMENTS(state, data) {
    state.adlDocuments = data;
  },

  SET_ADL_ATTACHMENTS(state, data) {
    state.adlAttachments = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
